import { handleActions } from "redux-actions";
import {
  getSelectedRangeOptionWithCustom,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getRangeOptions,
  getDateRanges
} from "../../../../utils/date-range-options";

import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_DATA_POINTS_SUCCESS,
  CHANGE_PERCENTAGE_TOGGLE,
  FETCH_TABLE_DATA_SUCCESS,
  SET_DATA_POINTS_LOADING,
  SET_TABLE_DATA_LOADING,
  YEAR_OVER_YEAR_LOADING,
  UPDATE_GROUP_BY_FILTER,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_LOADING,
  SET_HEAT_MAP_LOADING,
  FETCH_CHART_SUCCESS,
  FETCH_GRAPH_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_BREAKDOWN_CHART_FILTER,
  SET_FILTERS_DIRTY,
  UPDATE_FILTERS,
  RESET_FILTERS,
  UPDATE_DATES,
  SET_LOADING,
  SET_DATES,
  SET_BREAKDOWN_FILTER_LOADING,
  UPDATE_FUTURE_BOOKINGS,
  SET_DATES_FOR_FUTURE_BOOKING,
  RESET_BOOKING_STATUS_FILTER_SELECTED
} from "./serviceBookingsSagas";

const setIds = (arr) => {
  return arr?.map((item, idx) => {
    const itemId = item.replace(/\s/g, "") + idx;
    return { name: item, id: itemId };
  });
};

export const initialState = {
  currentUser: {},
  isLoading: true,
  yearOverYearLoading: true,
  isDataPointsLoading: true,
  isHeatMapLoading: true,
  tableDataLoading: true,
  show_percentage: false,
  graphData: {
    chartData: [],
    series: null
  },
  dataPoints: [],
  series: [],
  modalTableData: {},
  filtersDirty: false,
  selectedRequestDates: {},
  selectedFilters: {
    period_type: {
      id: 2,
      name: "Weekly"
    },
    group_by: { id: "not_grouped", name: "Not Grouped" },
    visit_names: [],
    membership_types: [],
    booking_statuses: [],
    staff_names: [],
    view: { id: "total", name: "Total" }
  },
  filters: {
    membership_types: [],
    visit_names: [],
    booking_statuses: [],
    view: [
      { id: "total", name: "Total" },
      { id: "bookings_status", name: "Bookings Status" }
    ],
    group_by: [
      { id: "not_grouped", name: "Not Grouped" },
      { id: "day_of_the_week", name: "Group by Day of the Week" },
      { id: "time_of_day", name: "Group by Time of Day" }
    ],
    period_type: [
      {
        id: 1,
        name: "Daily"
      },
      {
        id: 2,
        name: "Weekly"
      },
      {
        id: 3,
        name: "Monthly"
      },
      {
        id: 4,
        name: "Yearly"
      }
    ]
  },
  selectedRangeOption: {},
  rangeOptions: [],
  groupByWeekDay: false,
  groupByTimeOfDay: false,
  showPercentageToggle: true,
  breakdownFiltersLoader: null,
  future_bookings: false,
  minDate: null,
  maxDate: null
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      isFiltersLoading: action.payload
    }),
    [SET_BREAKDOWN_FILTER_LOADING]: (state, action) => ({
      ...state,
      breakdownFiltersLoader: action.payload
    }),
    [SET_HEAT_MAP_LOADING]: (state, action) => ({
      ...state,
      isHeatMapLoading: action.payload
    }),
    [SET_DATA_POINTS_LOADING]: (state, action) => ({
      ...state,
      isDataPointsLoading: action.payload
    }),
    [UPDATE_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, [key]: data }
    }),
    [YEAR_OVER_YEAR_LOADING]: (state, action) => ({
      ...state,
      yearOverYearLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action),
      minDate: null,
      maxDate: null
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [CHANGE_PERCENTAGE_TOGGLE]: (state, action) => ({
      ...state,
      show_percentage: action.payload
    }),
    [UPDATE_GROUP_BY_FILTER]: (state, action) => {
      const isNotGroupedSelected = action.payload.id === "not_grouped";

      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          group_by: action.payload
        },
        showPercentageToggle: isNotGroupedSelected
      };
    },
    [UPDATE_BREAKDOWN_CHART_FILTER]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload.data
      }
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [SET_TABLE_DATA_LOADING]: (state, action) => ({
      ...state,
      tableDataLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser
    }),
    [FETCH_GRAPH_SUCCESS]: (state, action) => ({
      ...state,
      graphData: {
        chartData: action.payload.chartData,
        series: action.payload.series || null
      }
    }),
    [FETCH_DATA_POINTS_SUCCESS]: (state, action) => ({
      ...state,
      dataPoints: action.payload
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      groupByTimeOfDay: state.selectedFilters.group_by.id === "time_of_day",
      groupByWeekDay: state.selectedFilters.group_by.id === "day_of_the_week"
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      modalTableData: action.payload.tableInfo,
      tableDataLoading: false
    }),
    [FETCH_FILTERS_SUCCESS]: (
      state,
      {
        payload: {
          membership_types = [],
          visit_names = [],
          booking_statuses = [],
          staff_names = []
        }
      }
    ) => {
      const formatedVisitNames = setIds(visit_names);
      const shouldAutoSelectBookingStatuses = !state.selectedFilters.booking_statuses.length;

      return {
        ...state,
        filters: {
          ...state.filters,
          membership_types,
          visit_names: formatedVisitNames,
          booking_statuses,
          staff_names
        },
        selectedFilters: {
          ...state.selectedFilters,
          visit_names: formatedVisitNames,
          membership_types,
          ...(shouldAutoSelectBookingStatuses && { booking_statuses }),
          staff_names
        }
      };
    },

    [UPDATE_FUTURE_BOOKINGS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      future_bookings: action.payload
    }),
    [SET_DATES_FOR_FUTURE_BOOKING]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload.selectedRequestDates,
      minDate: action.payload.minDate,
      maxDate: action.payload.maxDate,
      filtersDirty: true
    }),
    [RESET_BOOKING_STATUS_FILTER_SELECTED]: (state) => {
      const defaultStatusName = state.future_bookings ? "Open" : "Completed";
      const defaultStatus = state.filters.booking_statuses.filter(
        (option) => option.name === defaultStatusName
      );
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          booking_statuses: defaultStatus
        }
      };
    },
    [RESET_FILTERS]: (state) => ({
      ...initialState,
      currentUser: state.currentUser
    })
  },
  initialState
);
